import "./Tasks.css";

import { useContext } from "react";

import { ProjectPermissionConstants } from "../../../../../constants";
import { CompleteTaskModal, WorkflowTaskPanel } from "../../../../../templates/WorkflowTaskPanel";
import { Button, Column, CursorDataGrid, Row } from "../../../../../widget";
import { SelectWorkflowTemplateModal } from "../../../components/SelectWorkflowTemplateModal";
import { ProjectContext } from "../ProjectContext";
import { useDocuments } from "./useTasks";

const Tasks = (): JSX.Element => {
  const {
    columns,
    defaultSortingCriteria,
    dataIsLoading,
    projectDetails,

    showSelectWorkflowTemplateModal,
    setShowSelectWorkflowTemplateModal,

    showWorkflowTaskPanel,
    setShowWorkflowTaskPanel,
    handleCloseWorkflowTaskPanel,

    showCompleteTaskModal,
    handleCloseCompleteTaskModal,

    selectedCompleteTask,
    selectedPanelTask,

    workflow,

    refreshTasks,
    handleRefresh,

    navigateToTasksBoard,
    onChange,
  } = useDocuments();

  const { hasProjectPermission } = useContext(ProjectContext);

  return (
    <div className="ProjectTabSection">
      <Row spacingV="m">
        <Column span={6}>
          <h2>Tasks</h2>
        </Column>
        <Column span={6}>
          {hasProjectPermission(ProjectPermissionConstants.WRITE_PROJECT_DETAILS) && (
            <div className="ProjectTabSectionTasksButtons">
              {projectDetails?.workflowUuid === null ? (
                <Button
                  text="Apply workflow"
                  variant="tertiary"
                  fontWeight="light"
                  size="small"
                  onClick={() => setShowSelectWorkflowTemplateModal(true)}
                />
              ) : (
                <>
                  <Button
                    text="View tasks board"
                    variant="tertiary"
                    fontWeight="light"
                    size="small"
                    onClick={navigateToTasksBoard}
                  />
                  <Button
                    text="New task"
                    fontWeight="light"
                    size="small"
                    onClick={() => setShowWorkflowTaskPanel(true)}
                  />
                </>
              )}
            </div>
          )}
        </Column>
      </Row>
      <CursorDataGrid
        columns={columns}
        clientSide={false}
        filterable
        onChange={onChange}
        data={[]}
        refresh={refreshTasks}
        noDataMessage="No tasks to display"
        dataIsLoading={dataIsLoading}
        defaultSortingCriteria={defaultSortingCriteria}
      />
      {projectDetails && (
        <SelectWorkflowTemplateModal
          show={showSelectWorkflowTemplateModal}
          closeModal={() => setShowSelectWorkflowTemplateModal(false)}
          projectUuid={projectDetails.uuid}
          projectTypeUuid={projectDetails.projectType.uuid}
        />
      )}
      {selectedCompleteTask && (
        <CompleteTaskModal
          task={selectedCompleteTask}
          show={showCompleteTaskModal}
          closeModal={handleCloseCompleteTaskModal}
          closePanel={handleCloseCompleteTaskModal}
          handleRefresh={handleRefresh}
        />
      )}
      <WorkflowTaskPanel
        task={selectedPanelTask}
        currentStepUuid={selectedPanelTask?.step.uuid}
        workflow={workflow}
        show={showWorkflowTaskPanel}
        refresh={refreshTasks}
        handleRefresh={handleRefresh}
        onClose={handleCloseWorkflowTaskPanel}
      />
    </div>
  );
};

export default Tasks;
